module.exports = __webpack_public_path__ + "img/Hiraya-Icons-Pressure-Management.2c3471b2.png";